/**
 * Formateo de numeros para la demo. Separador de miles "." (formato es-ES) sin
 * depender de Intl (algunos entornos no traen datos de locale y no agrupan).
 */
export function formatInt(n) {
    if (n == null || isNaN(n)) return "";
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export default formatInt;
